

















































// Vue
import { defineComponent, PropType, computed, ref } from '@vue/composition-api'

// components
import { SwitchToggle } from '@/components/form'
import { Form, Input, Button, Icon, Radio } from '@/components/general'
import { Loading } from '@/components'

// models
import { DiscountTypeForm } from '@/models/config'

// services
import { DiscountTypesService } from '@/services/config'

// Vuelidate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

// utils
import { alerts, loading } from '@/utils'

// constants
import { optionsStatus } from '@/constants'

export default defineComponent({
  name: 'DiscountTypeFormCreateEdit',
  components: {
    Form,
    Input,
    Button,
    Icon,
    Loading,
    Radio,
    SwitchToggle
  },
  props: {
    item: {
      type: Object as PropType<DiscountTypeForm>,
      required: true
    },
    idEdit: {
      type: Number as PropType<number>,
      default: null
    },
    action: {
      type: String as PropType<'save'|'update'>,
      required: true
    }
  },
  setup (props, { emit }) {
    const isLoading = ref(false)
    const rules = computed(() => ({
      item: {
        name: { required },
        is_active: { required }
      }
    }))
    const $v = useVuelidate(rules, { item: props.item })

    const save = async () => {
      $v.value.item.$touch()
      if (!$v.value.item.$invalid) {
        try {
          loading('show')
          if (props.action === 'save') {
            await DiscountTypesService.create(props.item)
          } else {
            await DiscountTypesService.update(props.idEdit, props.item)
          }
          loading('hide')
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error('ERROR.! No se pudo completar la operación')
          loading('hide')
        }
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }
    return {
      save,
      $v,
      isLoading,
      optionsStatus
    }
  }
})
